import { getEffectiveCommercantId } from './assistanceSession.js';

/** Lit admin_user (JWT profil SA / commerçant — pas le token assistance). */
export function readAdminUser() {
  try {
    const raw = localStorage.getItem('admin_user');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

/** Boutique courante : assistance A1.2 prioritaire, sinon commerçant connecté. */
export function getOperationalCommercantId() {
  return getEffectiveCommercantId(readAdminUser());
}
